import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import todoImage from "../../Assets/Logo/todos_logo.png";
import todoImageLg from "../../Assets/Logo/todos_logo.png";

export const Logo = () => {
  return (
    <Container className="logo_container">
      <span className="logo_helper"></span>
      <Link to="/" className="logo_link">
        <span className="logo-lg">
          <img
            src={todoImageLg}
            className="logo"
            alt="Todo's Translator — Indianapolis In-Home Dog Training"
          />
        </span>
        <span className="logo-sm">
          <img src={todoImage} className="logo" alt="Todo's Translator logo" />
        </span>
      </Link>
    </Container>
  );
};
